import PropTypes from 'prop-types';
import { BodyCopy } from '../../ui/BodyCopy/BodyCopy';
import { badgesStyles } from './DiscountBadge.style';

export const DiscountBadge = ({ badge, size, lineHeight }) => {
  const getBadgeSize = () => {
    return size || 'copy5';
  };
  const badgesStylesWithLineHeight = badgesStyles(lineHeight);
  return (
    <div className="discount-badge">
      <BodyCopy size={getBadgeSize()} key={badge.label} isHighlighted>
        {(classes) => (
          <span
            id={`testId-Pod-badges-${badge.label}`}
            className={`${classes} discount-badge-item`}
            style={{
              backgroundColor: `${badge.styles.backgroundColor}`,
              color: `${badge.styles.textColor}`,
            }}
          >
            {badge.label}
          </span>
        )}
      </BodyCopy>
      <style jsx>{badgesStylesWithLineHeight}</style>
    </div>
  );
};

DiscountBadge.defaultProps = {
  size: null,
  lineHeight: null,
};

DiscountBadge.propTypes = {
  badge: PropTypes.object.isRequired,
  size: PropTypes.string,
  lineHeight: PropTypes.string,
};
